import React from 'react';
import { FaWhatsapp, FaFileAlt, FaSearch, FaCheckCircle } from 'react-icons/fa';

const HowItWorks = () => {
  const steps = [
    {
      icon: <FaWhatsapp />,
      title: 'Contáctanos',
      description: 'Contáctanos vía WhatsApp o formulario de contacto. Respondemos rápidamente.'
    },
    {
      icon: <FaFileAlt />,
      title: 'Comparte tu caso',
      description: 'Comparte los detalles de tu caso: tipo de cita, ciudad y documentos necesarios.'
    },
    {
      icon: <FaSearch />,
      title: 'Monitoreamos',
      description: 'Monitoreamos y gestionamos la disponibilidad de citas en tiempo real.'
    },
    {
      icon: <FaCheckCircle />,
      title: 'Recibes confirmación',
      description: 'Recibes los detalles de la cita confirmada con toda la información necesaria.'
    }
  ];

  return (
    <section id="how-it-works" className="how-it-works">
      <div className="how-it-works-bg-image">
        <img 
          src="https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=1200&q=80" 
          alt="Proceso de gestión de citas" 
          className="how-it-works-image"
        />
        <div className="how-it-works-overlay"></div>
      </div>
      <div className="container">
        <h2 className="section-title">Cómo Funciona</h2>
        <p className="section-subtitle">Proceso simple y transparente en 4 pasos</p>
        <div className="steps-grid">
          {steps.map((step, index) => (
            <div key={index} className="step-card">
              <div className="step-icon-circle">
                <div className="step-icon">{step.icon}</div>
              </div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
              {index < steps.length - 1 && <div className="step-arrow">→</div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
